import { Component, OnInit } from '@angular/core';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { BillingService } from 'src/home/billing/services/billing.service';
import { HomeService } from 'src/home/home.service';
import { PaginatorService } from 'src/home/paginator.service';
import { BillingResponse } from 'src/models/bills-list.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-bills-list',
  templateUrl: './bills-list.component.html',
  styleUrls: ['./bills-list.component.css'],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }],
})
export class BillsListComponent implements OnInit {



  billingResults: any[] = [];
  isLoading: boolean = false;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageSize: number = 10;
  totalBills: number = 0;


  billingResponse: BillingResponse = {
    pageNumber: 0,
    totalPages: 0,
    currentPageElements: 0,
    totalElements: 0,
    results: [],
  };



  constructor(
    private billingService: BillingService,
  ) { }

  ngOnInit(): void {
    this.handleGetBills(0);
  }


  handleGetBills(page: number): void {
    this.isLoading = true;
    this.billingService.getBills(page).subscribe(
      (data) => {
        this.isLoading = false;
        this.billingResponse = data;
        this.billingResults = data.results;
        console.log(this.billingResults);
        this.totalBills = data.totalElements;
      },
      (error) => {
        console.error('Error al cargar las facturas:', error);
        this.isLoading = false;
        Swal.fire({
          title: 'Error',
          text: 'Ha ocurrido un error al cargar las facturas. Por favor, inténtalo de nuevo.',
          icon: 'error',
          confirmButtonColor: '#d33',
        });
      }
    );
  }

  handlePageEvent($event: PageEvent): void {
    this.billingResponse.pageNumber = $event.pageIndex
    this.billingResponse.currentPageElements = $event.pageSize;
    this.billingResponse.totalElements = $event.length;
    this.handleGetBills($event.pageIndex + 1);
  }


  formatDate(dateString?: string): string {
    if (!dateString) return 'N/A'; // Devolver 'N/A' si dateString es undefined o vacío
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES');
  }


}
